export default "__VITE_ASSET__CU3owFOk__"